import GlobalConst, {tryGetFromLocalStorage} from "../constants/GlobalConst";

export function getSetKeyValueFromQS(qsKey, lsKey){
    let value = tryGetFromLocalStorage(lsKey);
    let searchParams = new URLSearchParams(window.location.search);
    if( searchParams.has(qsKey))
        value = searchParams.get(qsKey);
    if( value )
        try { localStorage.setItem(lsKey, value);} catch (ex) {}
    return value;
}

export function deepClone(obj) {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(item => deepClone(item));
    }
    const clonedObj = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            clonedObj[key] = deepClone(obj[key]);
        }
    }
    return clonedObj;
}